import React from "react";
import './Body17.css';
import {Link} from "react-router-dom"
import picture291 from './source/picture291.png'
import picture292 from './source/picture292.png'
import picture293 from './source/picture293.png'
import picture294 from './source/picture294.png'
import picture295 from './source/picture295.png'




function Body17() {

  return (
    <div className="body17">
      <div className="body17-box1">
        <div className="body17-box2">
          <div className="body17-box3">Hluk</div>
          <div className="body17-box5"><div className="body17-box4"></div></div>
          <div className="body17-box6">
          <img className="body17-box6-picture" src={picture291} alt="picture1"/>
          <img className="body17-box6-picture" src={picture292} alt="picture1"/>
          <img className="body17-box6-picture" src={picture293} alt="picture1"/>
          <img className="body17-box6-picture" src={picture294} alt="picture1"/>
          <img className="body17-box6-picture2" src={picture295} alt="picture1"/>
          </div>
          <div className="body17-box8"><div className="body17-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body17;
